import { render, staticRenderFns } from "./TelemedicineToStartTable.vue?vue&type=template&id=07bcabba&"
import script from "./TelemedicineToStartTable.vue?vue&type=script&lang=js&"
export * from "./TelemedicineToStartTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports